module.exports = "<div [innerHTML]=\"content\">   </div>\n"